import styles from "./TableBody.module.scss";
import { Dispatch, SetStateAction } from "react";
import { Loader } from "@/frontend/shared/ui/Loader/Loader";
import { buildCells } from "../RowCell/RowCell";
import { getRouteExpertPortfolioCompanyProfile } from "@/frontend/shared/const/router";
import { Typography } from "@/frontend/shared/ui/Typography";
import { useHistoricalNavigate } from "@/frontend/shared/lib/useHistoricalNavigate/useHistoricalNavigate";
import clsx from "clsx";
import { TOrganizationData } from "../../model/types/types";
import { Pagination } from "@/frontend/shared/ui/Pagination/Pagination";

type TTableBody = {
  data: TOrganizationData;
  triggerRefetch: () => void;
  companyHeaders?: { value: string; label: string }[];
  limit: number;
  setPage: Dispatch<SetStateAction<number>>;
  currentPage: number;
  isLoading: boolean;
  organizationId: number;
};

export function TableBody({
  data,
  triggerRefetch,
  isLoading,
  limit,
  setPage,
  currentPage,
  organizationId
}: TTableBody) {
  const { navigate } = useHistoricalNavigate();

  switch (true) {
    case isLoading:
      return (
        <div className={styles.loaderContainer}>
          <Loader />
        </div>
      );
    case !!data?.portfolioCompanies?.length:
      return (
        <>
          <div className={styles.cardContainer}>
            {data?.portfolioCompanies?.map((portfolioCompany, index) => {
              return (
                <div
                  key={index}
                  className={clsx(styles.card)}
                  onClick={() => navigate(getRouteExpertPortfolioCompanyProfile(organizationId, portfolioCompany.id))}
                >
                  {buildCells(portfolioCompany)}
                </div>
              );
            })}
          </div>
          <div className={styles.paginationContainer}>
            <Pagination
              setPage={setPage}
              companiesLimit={limit}
              currentPage={currentPage}
              className={styles.pagination}
              isLoading={isLoading}
              companiesTotal={data?.portfolioCompanies?.length || 0}
            />
          </div>
        </>
      );
    default:
      return (
        <div className={styles.emptyPageContainer}>
          <Typography variant="label-4" color="greyscale600">
            No matching companies found
          </Typography>
        </div>
      );
  }
}
